import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  thickDivider: {
    backgroundColor: 'gray.3',
    maxHeight: 24,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
    textAlign: 'left',
    paddingY: 0.5,
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'gray.3',
    border: 0,
    paddingY: 0.5,
  },
  dialogContent: { padding: 4 },
  mostRecent: { marginBottom: 2 },
  previousCheckIns: {
    marginBottom: 2,
  },
  previousCheckInsTitle: { marginRight: 1 },
  loading: {
    display: 'flex',
    justifyContent: 'center',
  },
  loadingContainer: {
    mt: 2,
  },
  mostRecentTitle: { marginRight: 1 },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 2,
  },
  userIcon: {
    fontSize: 40,
    color: 'gray.16',
  },
  icon: {
    color: 'gray.40',
    marginLeft: 3.5,
    marginRight: 1.25,
    fontSize: 16,
  },
  searchHelperText: {
    alignItems: 'center',
    lineHeight: 1.33,
  },
}
